module.exports = __webpack_public_path__ + "img/6.ec062222.webp";